
import '@attensi/materia/dist/style.css'
import '@attensi/materia/dist/opt-in-styles.css'
import { defineComponent } from 'vue'

export default defineComponent({})
